<template>
<div>
	<div v-if="widthMax > 768">
		<div class="container">
			<div class="row my-4">
				<div class="col-6 font-weight-bold">
					({{statPoint.length}}/{{allMentorList}}) MENTORS 
				</div>
				<!-- <div>
					<input type="checkbox" v-model="testaa">
				</div> -->
				<div class="col-6">
					<div class="row">
						<div class="col-8">
							<div class="input-icon">
								<i class="fas fa-search"></i>
								<input type="text" placeholder="Search mentor" name="" class="form-control" v-model="searchMentor">
							</div>
						</div>
						<div class="col">
							<div class="d-block btn-filter font-18 cr-pointer" @click="showFilter = !showFilter">
								<i class="fas fa-filter"></i> FILTERS 
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="py-2">
				<div v-for="(val,index) in Rating" class="objfilter ml-1" :key="index">
					<div>" {{getTextStart(val)}} " <i @click="remove('star',index)" class="fas fa-times-circle"></i></div>
				</div>
				<div v-for="(val,index) in Cat" class="objfilter ml-1" :key="index">
					<div >" {{getCategory(val)}} " <i @click="remove('category',index)" class="fas fa-times-circle"></i></div>
				</div>
			</div>
			<div class="row" v-infinite-scroll="loadMOre" infinite-scroll-distance="10">
				<div class="col-12 border rounded mb-3 px-4 py-4" v-for="(val,index) in statPoint" :key="index" >
					<div class="row">
						<div class="col-md-2 text-center">
							<div class="box-img-m mb-3 mx-auto" v-if="typeof val.detailUser[0].profilePic != 'undefined' && val.detailUser[0].profilePic != ''">
								<img class="mw-100" :src="proFilePic+val.detailUser[0].profilePic"> 
							</div>
							<div class="box-img-m mb-3 mx-auto" v-else>
								<img class="mw-100" src="@/assets/user.png">
							</div>
							<div class="mb-3" v-if="val.detailUser[0].amountHourly != null && typeof val.detailUser[0].amountHourly != 'undefined'">
								<strong>Price&nbsp;<span v-html="currencySymbol(val.detailUser[0].hourlyRate)">&nbsp;</span>{{val.detailUser[0].amountHourly | comma }}/hour</strong>
							</div>
							<button class="btn-review" data-toggle="modal" data-target="#reviewModal" @click="selectMentor(val)">
								Review
							</button>
						</div>
						<div class="col-md-10">
							<div class="row">
								<div class="col-8">
									<h4 class="font-20 text-capitalize">{{ val.detailUser[0].name}} {{ val.detailUser[0].surname}}, ({{val.detailUser[0].nickName}})
									<span v-if="val.reviewPoints > 0"> 
										<span class="font-size-15">Rating <span v-for="(value,key) in 5"  class="mr-2" :key="key"><i class="fas fa-star" :class="val.reviewPoints >= (key+1) ? 'text-orange' : 'text-muted'"></i></span>({{val.reviewPoints | floatNumber}})</span>
									</span>
									<span v-else class="font-size-15 text-secondary">
										No rate yet
									</span>
								<!-- <span v-for="(value,key) in val.reviewPoints" v-if="val.reviewPoints != null"  class="mr-2" :key="key"><i class="fas fa-star text-orange"></i></span> -->
									<!-- <span v-if="val.reviewPoints != null"  class="mr-2" ><i class="fas fa-star text-muted" :class="{'text-orange':val.reviewPoints == 1}"></i></span>
									<span v-if="val.reviewPoints != null"  class="mr-2" ><i class="fas fa-star text-muted" :class="{'text-orange':val.reviewPoints == 2}"></i></span>
									<span v-if="val.reviewPoints != null"  class="mr-2" ><i class="fas fa-star text-muted" :class="{'text-orange':val.reviewPoints == 3}"></i></span>
									<span v-if="val.reviewPoints != null"  class="mr-2" ><i class="fas fa-star text-muted" :class="{'text-orange':val.reviewPoints == 4}"></i></span>
									<span v-if="val.reviewPoints != null"  class="mr-2" ><i class="fas fa-star text-muted" :class="{'text-orange':val.reviewPoints == 5}"></i></span>
									</span> -->
									</h4>
								</div>
								<div class="col-4 text-right">
									<a @click="reviewDetail(val)" class="text-muted font-18 cr-pointer" >
										Review detail
									</a>
								</div>
							</div>
							<div class="row color-grey-dark">
								<div class="col-12" v-if="val.detailUser[0].professionTitle != '' && val.detailUser[0].professionTitle != null && typeof val.detailUser[0].professionTitle != 'undefined'">
									 "{{val.detailUser[0].professionTitle}}"
								</div>
								<div class="col-12" v-if="val.detailUser[0].living != '' && typeof val.detailUser[0].living != 'undefined'">
					             Living in: <span v-if="val.detailUser[0].living != '' && typeof val.detailUser[0].living != 'undefined'">{{ val.detailUser[0].living }}</span>
					          </div>
								<div class="col-12 my-3" v-if="val.detailUser[0].language != null && typeof val.detailUser[0].language != 'undefined' && val.detailUser[0].language.length > 0">
									Talk well in: <span v-for="(data,indexlangage) in val.detailUser[0].language" :key="indexlangage"> {{ `${data.name}` }}<span v-if="val.detailUser[0].language.length-1 > indexlangage">,</span>  </span>
								</div>
								<div class="col-12 my-2" v-if="typeof val.detailUser[0].social != 'undefined'">
									<nav class="level is-mobile">
								      <div class="level-left d-flex" >
								        <a title="facebook"  target="_blank" :href="'https://www.facebook.com'" class="level-item mr-2">
								            <div class="circle-social">
								            <i class="fab fa-facebook-f"></i>
								            </div>
								        </a>
								        <a title="linkedin" v-if="val.detailUser[0].social.linkedin && val.detailUser[0].social.linkedin != null && typeof val.detailUser[0].social.linkedin != 'undefined' && typeof val.detailUser[0].social != 'undefined'"  target="_blank" :href="'https://'+val.detailUser[0].social.linkedin" class="level-item mr-2">
								          <div class="circle-social">
								            <i class="fab fa-linkedin-in"></i>
								          </div>
								        </a>
								          <a title="line" v-if="val.detailUser[0].social.line && val.detailUser[0].social.line != null && typeof val.detailUser[0].social.line != 'undefined' && typeof val.detailUser[0].social != 'undefined'"  target="_blank" :href="'https://'+val.detailUser[0].social.line" class="level-item mr-2">
								             <div class="circle-social">
								            <i class="fab fa-line"></i>
								            </div>
								        </a>
								        <a title="skype" v-if="val.detailUser[0].social.skype  && val.detailUser[0].social.skype != null && typeof val.detailUser[0].social.skype != 'undefined' && typeof val.detailUser[0].social != 'undefined'"  target="_blank" :href="'https://'+val.detailUser[0].social.skype" class="level-item mr-2">
								             <div class="circle-social">
								            <i class="fab fa-skype"></i>
								            </div>
								        </a>
								        <a title="hangout" v-if="val.detailUser[0].social.hangouts && val.detailUser[0].social.hangouts != null && typeof val.detailUser[0].social.hangouts != 'undefined' && typeof val.detailUser[0].social != 'undefined'"  target="_blank" :href="'https://'+val.detailUser[0].social.hangouts" class="level-item mr-2">
								             <div class="circle-social">
								            <span>H</span> 
								            </div>
								        </a>
								         <a title="zoom" v-if="val.detailUser[0].social.zoom && val.detailUser[0].social.zoom != null && typeof val.detailUser[0].social.zoom != 'undefined' && typeof val.detailUser[0].social != 'undefined'"  target="_blank" :href="'https://'+val.detailUser[0].social.zoom" class="level-item mr-2">
								             <div class="circle-social">
								             <span>Z</span>
								            </div>
								        </a>
								      </div>
								    </nav>
								</div>	
								<div class="col-12">
									<hr>
								</div>
								<div class="col-12" v-if="val.detailUser[0].aboutMe != '' && typeof val.detailUser[0].aboutMe != 'undefined' && val.detailUser[0].aboutMe != null">
									<div>{{val.detailUser[0].aboutMe}}</div>
								</div>
								<div class="col-12 mt-4">
									<div class="bg-grey rounded py-2 px-3 mr-3 mb-3 d-inline-block" v-for="(data,indexOfDetils) in val.detailUser[0].industryExpertise" :key="indexOfDetils">
										{{data.name}}
									</div>
								</div>
							</div>	
						</div>
					</div>
				</div>
				<div v-if="statPoint.length === 0" class="row mx-auto m-5 LOADMORE cr-pointer" @click="loadMOre()" >
					<div class="col-12">
						*** Nothing review ***
					</div>
				</div>
				<div v-if="loaddingLimit" class="row mx-auto m-2">
					<div class="spinner-border text-secondary" role="status">
						<span class="sr-only">Loading...</span>
					</div>
				</div>
			</div>
		</div>
		<div class="filterList p-3" :class="showFilter ? 'show':''">
			<div class=" text-right">
				<i @click="showFilter = !showFilter" class="cr-pointer fas fa-times"></i>
			</div>
			<div>
				RATING
			</div>
			<div><hr></div>
			<div class="text-orange">
				<div>
					<input type="checkbox" v-model="Rating" :value="1" class="mr-2"> 
					<i class="fas fa-star"></i>
				</div>
				<div>
					<input type="checkbox" v-model="Rating" :value="2" class="mr-2"> 
					<i class="fas fa-star"></i>
					<i class="fas fa-star"></i>
				</div>
				<div>
					<input type="checkbox" v-model="Rating" :value="3" class="mr-2"> 
					<i class="fas fa-star"></i> 
					<i class="fas fa-star"></i> 
					<i class="fas fa-star"></i>
				</div>
				<div>
					<input type="checkbox" v-model="Rating" :value="4" class="mr-2"> 
					<i class="fas fa-star"></i>
					<i class="fas fa-star"></i> 
					<i class="fas fa-star"></i> 
					<i class="fas fa-star"></i> 
				</div>
				<div>
					<input type="checkbox" v-model="Rating" :value="5" class="mr-2"> 
					<i class="fas fa-star"></i>
					<i class="fas fa-star"></i>
					<i class="fas fa-star"></i>
					<i class="fas fa-star"></i>
					<i class="fas fa-star"></i>
				</div>
			</div>
			<div class="text-uppercase mt-4">
				Category  
			</div>
			<div><hr></div>                           
			<div>
				<div v-for="(data,index) in category" :key="index" class="mb-2">
					<input type="checkbox" v-model="Cat" :value="index"> {{data.name}} 
				</div>
			</div>
			<div class="mt-5">
		
				<button class="btn-review" data-toggle="modal" @click="clearFilter()">
					clear all filters
				</button>
			</div>
		</div>
		<div class="modal fade bd-example-modal-lg" id="reviewModal" tabindex="-1" role="dialog" aria-labelledby="reviewModal" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                  	<div class="modal-body">
                        <h3 class="text-center">Review</h3>
                        <div class="form-group">
                        	<label>
                            	<b>Mentor </b><span>{{dataReview.reviewToName}}</span>
                        	</label>    
                        </div>
                        <div class="form-group">
                        	<label>
                           		<b>Title</b> 
                        	</label>    
                           	<div>
                        		<input v-model="dataReview.review.title" type="text" class="form-control" name="" placeholder="Title">
                           	</div>
                        </div>
                        <div class="form-group">
                           	<label>
                               	<b>Detail</b>
                           	</label>    
                           	<div>
                             	<textarea v-model="dataReview.review.detail" class="form-control" rows="6"></textarea>
                        	</div>
                        </div>
                        <div class="form-group">
							<b>Rate </b> <span v-for="(data,index) in 5" @click="dataReview.review.rating = index+1,validateRate = false" :key="index" class="mr-2"><i class="fas fa-star" :class="dataReview.review.rating >= (index+1) ? 'text-orange' : 'text-muted'"></i></span>
							<p class="text-danger" v-if="validateRate == true">Please rate your mentor</p>
                        </div>
                        <div class="form-group"> 
                            <div>
                                <label>
                                    <b>Review by </b><span>{{dataReview.review.reviewByName}} </span> <input v-model="dataReview.review.anonymous" type="checkbox" name=""> <span class="text-muted"> Anonymous</span>
                                </label>   
                            </div>
                        </div>
                        <div class="form-group"> 
                        	<div class="col-6 mx-auto">
                        		<button @click="submitReview()" v-if="validateRate == true" class="btn-comment w-100">SUBMIT</button>
                        		<button @click="submitReview()" v-else data-dismiss="modal" class="btn-comment w-100">SUBMIT</button>
                        	</div>
	                    </div>
                  	</div>
                </div>
            </div>
        </div>
	</div>
	<div v-else>
		<div class="container">
			<div class="row my-4 text-center">
				<div class="col-12 font-weight-bold ">
					({{statPoint.length}}/{{allMentorList}}) MENTORS 
				</div>
				<div class="col-12">
					<div class="row justify-center">
						<div class="col-12 my-3">
							<div class="input-icon">
								<i class="fas fa-search"></i>
								<input type="text" placeholder="Search mentor" name="" class="form-control" v-model="searchMentor">
							</div>
						</div>
						<div class="col-6 text-center ">
							<div class="d-block btn-filter font-18 cr-pointer" @click="showFilter = !showFilter">
								<i class="fas fa-filter"></i> FILTERS 
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="py-2">
				<div v-for="(val,index) in Rating" class="objfilter ml-1" :key="index">
					<div>" {{getTextStart(val)}} " <i @click="remove('star',index)" class="fas fa-times-circle"></i></div>
				</div>
				<div v-for="(val,index) in Cat" class="objfilter ml-1" :key="index">
					<div >" {{getCategory(val)}} " <i @click="remove('category',index)" class="fas fa-times-circle"></i></div>
				</div>
			</div>
			<div class="row" v-infinite-scroll="loadMOre" infinite-scroll-distance="10">
				<div class="col-12 border rounded mb-3 px-4 py-4" v-for="(val,index) in statPoint" :key="index">
					<div class="row">
						<div class="col-md-2 text-center">
							<div class="box-img-m mb-3 mx-auto" v-if="typeof val.detailUser[0].profilePic != 'undefined' && val.detailUser[0].profilePic != ''">
								<img class="mw-100" :src="proFilePic+val.detailUser[0].profilePic"> 
							</div>
							<div class="box-img-m mb-3 mx-auto" v-else>
								<img class="mw-100" src="@/assets/user.png">
							</div>
							<div class="mb-3" v-if="val.detailUser[0].amountHourly != null && typeof val.detailUser[0].amountHourly != 'undefined'">
								<strong>Price&nbsp;<span v-html="currencySymbol(val.detailUser[0].hourlyRate)">&nbsp;</span>{{val.detailUser[0].amountHourly | comma }}/hour</strong>
							</div>
							<button class="btn-review" data-toggle="modal" data-target="#reviewModal" @click="selectMentor(val)">
								Review
							</button>
						</div>
						<div class="col-md-10">
							<div class="row">
								<div class="col-12 text-center">
									<h4 class="font-20">{{ val.detailUser[0].name  }} {{ val.detailUser[0].surname  }}, ({{val.detailUser[0].nickName}}) 
								<!-- <span v-for="(value,key) in val.reviewPoints" v-if="val.reviewPoints != null"  class="mr-2" :key="key"><i class="fas fa-star text-orange"></i></span> -->
									<!-- <span v-if="val.reviewPoints != null"  class="mr-2" ><i class="fas fa-star text-muted" :class="{'text-orange':val.reviewPoints == 1}"></i></span>
									<span v-if="val.reviewPoints != null"  class="mr-2" ><i class="fas fa-star text-muted" :class="{'text-orange':val.reviewPoints == 2}"></i></span>
									<span v-if="val.reviewPoints != null"  class="mr-2" ><i class="fas fa-star text-muted" :class="{'text-orange':val.reviewPoints == 3}"></i></span>
									<span v-if="val.reviewPoints != null"  class="mr-2" ><i class="fas fa-star text-muted" :class="{'text-orange':val.reviewPoints == 4}"></i></span>
									<span v-if="val.reviewPoints != null"  class="mr-2" ><i class="fas fa-star text-muted" :class="{'text-orange':val.reviewPoints == 5}"></i></span>
									</span> -->
									</h4>
									<div >
										<h4 class="font-20">
											<span class="font-size-15">Rating <span v-for="(value,key) in 5"  class="mr-2" :key="key"><i class="fas fa-star" :class="val.reviewPoints >= (key+1) ? 'text-orange' : 'text-muted'"></i></span>({{val.reviewPoints | floatNumber}})</span>
										</h4>
									</div>
								</div>
								<div class="col-12 text-center text-underline">
									<a @click="reviewDetail(val)" class="text-muted font-18 cr-pointer" >
										Review detail
									</a>
								</div>
							</div>
							<div class="row color-grey-dark">
								<div class="col-12" v-if="val.detailUser[0].professionTitle != '' && val.detailUser[0].professionTitle != null && typeof val.detailUser[0].professionTitle != 'undefined'">(Profession title) {{val.detailUser[0].professionTitle}}
								</div>
								<div class="col-12" v-if="val.detailUser[0].living != '' && typeof val.detailUser[0].living != 'undefined'">
					             <strong>Living in :</strong> <span v-if="val.detailUser[0].living != '' && typeof val.detailUser[0].living != 'undefined'"> {{ val.detailUser[0].living }}</span>
					          </div>
								<div class="col-12 my-3" v-if="val.detailUser[0].language != null && typeof val.detailUser[0].language != 'undefined' && val.detailUser[0].language.length > 0">
									<strong>Talk well in :</strong> <span v-for="(data,indexlangage) in val.detailUser[0].language" :key="indexlangage"> {{ `${data.name}` }}<span v-if="val.detailUser[0].language.length-1 > indexlangage">,</span>  </span>
								</div>
								<div class="col-12 my-2" v-if="typeof val.detailUser[0].social != 'undefined'">
									<nav class="level is-mobile">
								      <div class="level-left d-flex" >
								        <a title="facebook"  target="_blank" :href="'https://www.facebook.com'" class="level-item mr-2">
								            <div class="circle-social">
								            <i class="fab fa-facebook-f"></i>
								            </div>
								        </a>
								        <a title="linkedin" v-if="val.detailUser[0].social.linkedin && val.detailUser[0].social.linkedin != null && typeof val.detailUser[0].social.linkedin != 'undefined' && typeof val.detailUser[0].social != 'undefined'"  target="_blank" :href="'https://'+val.detailUser[0].social.linkedin" class="level-item mr-2">
								          <div class="circle-social">
								            <i class="fab fa-linkedin-in"></i>
								          </div>
								        </a>
								          <a title="line" v-if="val.detailUser[0].social.line && val.detailUser[0].social.line != null && typeof val.detailUser[0].social.line != 'undefined' && typeof val.detailUser[0].social != 'undefined'"  target="_blank" :href="'https://'+val.detailUser[0].social.line" class="level-item mr-2">
								             <div class="circle-social">
								            <i class="fab fa-line"></i>
								            </div>
								        </a>
								        <a title="skype" v-if="val.detailUser[0].social.skype  && val.detailUser[0].social.skype != null && typeof val.detailUser[0].social.skype != 'undefined' && typeof val.detailUser[0].social != 'undefined'"  target="_blank" :href="'https://'+val.detailUser[0].social.skype" class="level-item mr-2">
								             <div class="circle-social">
								            <i class="fab fa-skype"></i>
								            </div>
								        </a>
								        <a title="hangout" v-if="val.detailUser[0].social.hangouts && val.detailUser[0].social.hangouts != null && typeof val.detailUser[0].social.hangouts != 'undefined' && typeof val.detailUser[0].social != 'undefined'"  target="_blank" :href="'https://'+val.detailUser[0].social.hangouts" class="level-item mr-2">
								             <div class="circle-social">
								            <span>H</span> 
								            </div>
								        </a>
								         <a title="zoom" v-if="val.detailUser[0].social.zoom && val.detailUser[0].social.zoom != null && typeof val.detailUser[0].social.zoom != 'undefined' && typeof val.detailUser[0].social != 'undefined'"  target="_blank" :href="'https://'+val.detailUser[0].social.zoom" class="level-item mr-2">
								             <div class="circle-social">
								             <span>Z</span>
								            </div>
								        </a>
								      </div>
								    </nav>
								</div>	
								<div class="col-12">
									<hr>
								</div>
								<div class="col-12" v-if="val.detailUser[0].aboutMe != '' && typeof val.detailUser[0].aboutMe != 'undefined' && val.detailUser[0].aboutMe != null">
									<div>{{val.detailUser[0].aboutMe}}</div>
								</div>
								<div class="col-12 mt-4">
									<div class="bg-grey rounded py-2 px-3 mr-3 mb-3 d-inline-block" v-for="(data,indexOfDetils) in val.detailUser[0].industryExpertise" :key="indexOfDetils">
										{{data.name}}
									</div>
								</div>
							</div>	
						</div>
					</div>
				</div>
				<div v-if="statPoint.length === 0" class="row mx-auto m-5 LOADMORE cr-pointer" @click="loadMOre()" >
					<div class="col-12">
						*** Nothing review ***
					</div>
				</div>
				<div v-if="loaddingLimit" class="row mx-auto m-2">
					<div class="spinner-border text-secondary" role="status">
						<span class="sr-only">Loading...</span>
					</div>
				</div>
			</div>
		</div>
		<div class="filterList p-3" :class="showFilter ? 'show':''">
			<div class=" text-right">
				<i @click="showFilter = !showFilter" class="cr-pointer fas fa-times"></i>
			</div>
			<div>
				RATING
			</div>
			<div><hr></div>
			<div class="text-orange">
				<div>
					<input type="checkbox" v-model="Rating" :value="1" class="mr-2"> 
					<i class="fas fa-star"></i>
				</div>
				<div>
					<input type="checkbox" v-model="Rating" :value="2" class="mr-2"> 
					<i class="fas fa-star"></i>
					<i class="fas fa-star"></i>
				</div>
				<div>
					<input type="checkbox" v-model="Rating" :value="3" class="mr-2"> 
					<i class="fas fa-star"></i> 
					<i class="fas fa-star"></i> 
					<i class="fas fa-star"></i>
				</div>
				<div>
					<input type="checkbox" v-model="Rating" :value="4" class="mr-2"> 
					<i class="fas fa-star"></i>
					<i class="fas fa-star"></i> 
					<i class="fas fa-star"></i> 
					<i class="fas fa-star"></i> 
				</div>
				<div>
					<input type="checkbox" v-model="Rating" :value="5" class="mr-2"> 
					<i class="fas fa-star"></i>
					<i class="fas fa-star"></i>
					<i class="fas fa-star"></i>
					<i class="fas fa-star"></i>
					<i class="fas fa-star"></i>
				</div>
			</div>>
			<div class="text-uppercase mt-4">
				Category  
			</div>
			<div><hr></div>                           
			<div>
				<div v-for="(data,index) in category" :key="index" class="mb-2">
					<input type="checkbox" v-model="Cat" :value="index"> {{data.name}} 
				</div>
			</div>
			<div class="mt-5">
		
				<button class="btn-review" data-toggle="modal" @click="clearFilter()">
					clear all filters
				</button>
			</div>
		</div>
		<div class="modal fade bd-example-modal-lg" id="reviewModal" tabindex="-1" role="dialog" aria-labelledby="reviewModal" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                  	<div class="modal-body">
                        <h3 class="text-center">Review</h3>
                        <div class="form-group">
                        	<label>
                            	<b>Mentor </b><span>{{dataReview.reviewToName}}</span>
                        	</label>    
                        </div>
                        <div class="form-group">
                        	<label>
                           		<b>Title</b> 
                        	</label>    
                           	<div>
                        		<input v-model="dataReview.review.title" type="text" class="form-control" name="" placeholder="Title">
                           	</div>
                        </div>
                        <div class="form-group">
                           	<label>
                               	<b>Detail</b>
                           	</label>    
                           	<div>
                             	<textarea v-model="dataReview.review.detail" class="form-control" rows="6"></textarea>
                        	</div>
                        </div>
                        <div class="form-group">
							<span v-if="dataReview.review.rating  > 0" class="font-size-15">
								<b>Rate </b> <span v-for="(data,index) in 5" @click="dataReview.review.rating = index+1,validateRate = false" :key="index" class="mr-2"><i class="fas fa-star" :class="dataReview.review.rating >= (index+1) ? 'text-orange' : 'text-muted'"></i></span>
							</span>
							<span v-else class="font-size-15 text-secondary">
								No rate yet
							</span>
							<p class="text-danger" v-if="validateRate == true">Please rate your mentor</p>
                        </div>
                        <div class="form-group"> 
                            <div>
                                <label>
                                    <b>Review by </b><span>{{dataReview.review.reviewByName}} </span> <input v-model="dataReview.review.anonymous" type="checkbox" name=""> <span class="text-muted"> Anonymous</span>
                                </label>   
                            </div>
                        </div>
                        <div class="form-group"> 
                        	<div class="col-6 mx-auto">
                        		<button @click="submitReview()" v-if="validateRate == true" class="btn-comment w-100">SUBMIT</button>
                        		<button @click="submitReview()" v-else data-dismiss="modal" class="btn-comment w-100">SUBMIT</button>
                        	</div>
	                    </div>
                  	</div>
                </div>
            </div>
        </div>
	</div>
</div>
</template>
<script>
	import {HTTPTicket,HTTPMentor,HTTPReview} from '@/axios.js'
import { filter } from 'minimatch';
import { type } from 'os';
	export default{
		data(){
			return{
				widthMax: window.innerWidth,
				showFilter:false,
				category:[],
				allMentorList:null,
				dataReview:{
					ticket:'',
					typeSystem:'',
					reviewTo:'',
					reviewToName:'',
					review:{
						reviewExport:'',
						ticket:'',
						category:'',
						title:'',
						detail:'',
						rating:0,
						reviewBy:'',
						reviewByName:'',
						reviewBySurname:'',
						anonymous:false
					},
					// mockup:[
					// 	{
					// 	name:'ham',
					// 	surname:'set',
					// 	cat:{
					// 			index:null,
					// 			name:'muteroo'
					// 		}
					// 	},
					// 	{
					// 	name:'beer',
					// 	surname:'cheer',
					// 	cat:{
					// 			index:null,
					// 			name:'manoon'
					// 		}
					// 	},
					// 		{
					// 	name:'aa',
					// 	surname:'bb',
					// 	cat:{
					// 			index:null,
					// 			name:'dd'
					// 		}
					// 	}
					// ]
				},
				Cat:[],
				Rating:[],
				limit:5,
				proFilePic:process.env.VUE_APP_IMG_PROFILE,
				searchMentor:'',
				validateRate:false,
				loaddingLimit:false
				
			}
		},
		created(){

			this.dataReview.review.typeSystem = this.user.typeSystem
			this.dataReview.review.reviewBy = this.user.uid
			this.dataReview.review.reviewByName = this.user.name
			this.dataReview.review.reviewBySurname = this.user.surname
			this.dataReview.review.reviewExport = this.user.userExport	
			this.fetchCategory()
		},
		methods:{
			loadMOre(){
				if(this.statPoint.length < this.allMentorList){
					this.loaddingLimit = true
					setTimeout(() => {
						this.loaddingLimit = false
						this.limit += 10;
					}, 500);
				}
			},
			reviewDetail(value){
				this.$store.commit('setMentorDetail',value)
				this.$router.push('/review-detail')
			},
			selectMentor(value){
				if(typeof value.detailUser[0].name != 'undefined' && typeof value.detailUser[0].surname != 'undefined'){
					this.dataReview.reviewToName = value.detailUser[0].name+' '+value.detailUser[0].surname
				}
				this.dataReview.reviewTo = value.userId
			},
			currencySymbol(val){
              let data = this.currency.filter(search =>{
                return search.code == val
              })
              return data[0].symbol
          	},
      		submitReview(){
      			if(this.dataReview.review.rating == 0){
		          this.validateRate = true
		        }else{
	          		let dataMentor = this.mentorList.filter(search =>{
	          			return search.userId == this.dataReview.reviewTo
	          			console.log('search.userId',search.userId)
					})	
	          		this.$store.commit('setMentorDetail',dataMentor[0])
	          		HTTPReview.defaults.headers.common.Authorization = `Bearer ${this.user.token}`;
	          		HTTPReview.post('/api/create/review',this.dataReview).then(res=>{
	          			if(res.data.success){
	          				this.$router.push('/review-detail')
	          			}
	          			
	          		})
          		}
      		},
			fetchCategory(){
				HTTPTicket.defaults.headers.common.Authorization = `Bearer ${this.user.token}`;
				HTTPTicket.post('api/get/all/category').then(res=>{
					console.log('api/get/all/category',res)
					this.category = res.data.obj
				})
			},
			clearFilter(){
				this.Rating = [];
				this.Cat = [];
			},
			getTextStart(star){
				let text = ''
				switch (star) {
					case 1:
						text = '1 Star'
						break;
					case 2:
						text = '2 Star'
						break;
					case 3:
						text = '3 Star'
						break;
					case 4:
						text = '4 Star'
						break;
					case 5:
						text = '5 Star'
						break;
				
					default:
						break;
				}
				return text
			},
			getCategory(index){
				let cat = this.category.filter(item => item.index === index)
				if (cat.length > 0) {
					return cat[0].name
				}else{
					return ''
				}
			},
			remove(val,index){
				if(val == 'star' ){
					this.Rating.splice(index, 1)
				}else if(val == 'category'){
					this.Cat.splice(index, 1)
				}
          	},
		},
		computed:{
			currency(){
	            return this.$store.state.currency
	        },
			user(){
				return this.$store.state.user
			},
			mentorList(){
				return this.$store.state.menTorList
			},
			setMentorList(){
				let mentor = []
				this.$store.state.menTorList.map((item)=>{
					if (item.detailUser.length > 0 && 
						typeof item.detailUser[0].aboutMe !== 'undefined' &&
						typeof item.detailUser[0].industryExpertise !== 'undefined' &&
						typeof item.detailUser[0].profilePic !== 'undefined' &&
						item.detailUser[0].aboutMe !== '' &&
						item.detailUser[0].aboutMe !== null &&
						item.detailUser[0].industryExpertise.length > 0 && 
						item.detailUser[0].profilePic !== '' &&
						item.detailUser[0].profilePic !== null) {
					mentor.push(item)
					}
				})
				if(this.searchMentor != ''){
					let allData = []

					mentor.map(item=>{
					let filterData = item.detailUser.filter(val=>{
								return  (
								(typeof val.professionTitle !== 'undefined' && val.professionTitle !== null && val.professionTitle !== ''  && (val.professionTitle.toLowerCase().indexOf(this.searchMentor.toLowerCase()) >-1))
								|| (typeof val.name !== 'undefined' && val.name !== null && val.name !== ''  && (val.name.toLowerCase().indexOf(this.searchMentor.toLowerCase()) >-1))
								|| (typeof val.nickName !== 'undefined' && val.nickName !== null && val.nickName !== ''  && (val.nickName.toLowerCase().indexOf(this.searchMentor.toLowerCase()) >-1))
								|| (typeof val.surname !== 'undefined' && val.surname !== null && val.surname !== ''  && (val.surname.toLowerCase().indexOf(this.searchMentor.toLowerCase()) >-1))
								|| (typeof val.cityDistrict !== 'undefined' && val.cityDistrict !== null && val.cityDistrict !== ''  && (val.cityDistrict.toLowerCase().indexOf(this.searchMentor.toLowerCase()) >-1))
								|| (typeof val.country !== 'undefined' && val.country !== null && val.country !== ''  && (val.country.toLowerCase().indexOf(this.searchMentor.toLowerCase()) >-1))
								|| (typeof val.aboutMe !== 'undefined' && val.aboutMe !== null && val.aboutMe !== ''  && (val.aboutMe.toLowerCase().indexOf(this.searchMentor.toLowerCase()) >-1))
								|| (typeof val.aboutMe !== 'undefined' && val.aboutMe !== null && val.aboutMe !== ''  && (val.aboutMe.toLowerCase().indexOf(this.searchMentor.toLowerCase()) >-1))
								// || (typeof val.language !== 'undefined' && val.language !== null && val.language !== '' && (val.language.toLowerCase().indexOf(this.searchMentor.toLowerCase()) >-1))
								)
					});
					if(filterData.length > 0){
						
						allData.push(item)
					}
							
						})
						console.log('aaaaaaaaa',allData)
							this.allMentorList = allData.length
							return allData
						}else{
							this.allMentorList = mentor.length
							return mentor.slice(0,this.limit)
						}	
			},
			catData(){
				if(this.Cat.length > 0){
				let dataAll =[]
				this.setMentorList.map(data=>{
					if(typeof data.detailUser[0].industryExpertise === 'undefined'){
					}else{
					let details = data.detailUser[0].industryExpertise.filter(item => {
						this.Cat.map(val=> {
						 	 	if(val == item.index){
									let valu =	dataAll.filter(dataId =>{
											return dataId.userId == data.userId
									})
									if(valu.length == 0){
										dataAll.push(data)
									}
					 			}
							})
						})
					}
				})
				return dataAll
				}else{
					this.allMentorList = this.$store.state.menTorList.length
					return this.setMentorList
				}	
			},
			statPoint(){
				if(this.Rating.length > 0){
				let dataAll =[]
				this.catData.filter(item =>{
					this.Rating.map(data =>{
						if(item.reviewPoints != null){
							console.log('asdsad',item.reviewPoints,data)
							if(data == item.reviewPoints){
								let valu =	dataAll.filter(dataId =>{
										return dataId.userId == item.userId
								})
								console.log('valu',valu)
								if(valu.length == 0){
									dataAll.push(item)
								}
							}
						}
						 
					})
				})
				console.log('test',dataAll)
				return dataAll
				}else{
					return this.catData
				}	
			},
		}
	}
</script>
<style scoped>
	.filterList.show{
		right: 0;
	}
	.filterList{
		transition: all 0.4s;
		--webkit-transition: all 0.4s;
		width: 400px;
		position:fixed;
		top: 0;
		bottom: 0;
		right:-500px;
		background: #fff;
		-webkit-box-shadow: -2px 0px 5px 0px rgba(173,173,173,1);
		-moz-box-shadow: -2px 0px 5px 0px rgba(173,173,173,1);
		box-shadow: -2px 0px 5px 0px rgba(173,173,173,1);
	}
	.font-size-15{
		font-size: 15px;
	}
	.objfilter{
	/* float: left; */
		background: linear-gradient(180deg, #FD7900 -34.44%, #FFCB2A 133.33%);
		padding-left: .5rem;
		padding-right: .5rem;
		padding-top: .25rem;
		padding-bottom: .25rem;
		display: inline-block;
		color: white;
		border-radius: 40px;
		cursor: pointer;
		margin-top: 10px;
	}
	.objfilter:hover{
		background: white;
		box-shadow: 0 0 0 1px #FD7900;
		color: #FD7900;
	}
	.objfilter:hover .fas{
	color: #FD7900;
	}
</style>